import {Component, Input, OnInit} from '@angular/core';
import {AdminService} from "../../../services/AdminService";

@Component({
    selector: 'app-admin-field-popup',
    templateUrl: './admin-field-popup.component.html',
    styleUrls: ['./admin-field-popup.component.scss'],
})
export class AdminFieldPopupComponent implements OnInit {

    @Input()
    prefix;
    @Input()
    model;
    @Input()
    exTableData;
    @Input()
    fieldType;
    @Input()
    fieldData;
    @Input()
    sectionName;

    tableInfoData;
    ready = true;

    constructor(public adminService:AdminService) {
    }

    ngOnInit() {
        this.tableInfoData = this.exTableData[this.sectionName + 'Data'];
    }

}
